var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-element columns is-gapless is-centered"},[_c('div',{staticClass:"colum"},[_c('figure',{staticClass:"image"},[_c('LazyLoadedImage',{staticClass:"",attrs:{"src":_vm.imgSrc,"alt":"Hero Banner"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }